<template>
  <div>
    <h3>
      <span>{{ $t('message.script_status_disk_space_monitoring') | title }}</span>
    </h3>

    <div v-if="description">{{description}}</div>
    <div>
      <vue-chartist :data="diskSpaceHistoryData" :options="diskSpaceHistoryOptions" type="Line"/>
    </div>

    <div v-if="estimatedWarningDays">
      {{$t('message.disk_space_monitoring_estimated_warning', {'days': estimatedWarningDays} )}}
    </div>
    <b-form>
      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t('message.disk_space_monitoring_warn_email')}}
          </label>
        </div>
        <div class="col-6">
          <b-form-input type="email" v-model="monitoringConfig.warn_email"/>
        </div>
      </b-form-row>

      <b-form-row>
        <div class="col-4">
          <label class="label label-default">
            {{$t('message.disk_space_monitoring_warning_used_percent')}}
          </label>
        </div>
        <div class="col-4">
          <b-form-input type="range" v-model="monitoringConfig.warning_used_percent" :min="50" :max="95" :step="1"/>
        </div>
        <div class="col-2">
          {{monitoringConfig.warning_used_percent}} %
        </div>
      </b-form-row>
    </b-form>

    <div>
      <b-button class="padmin-button submit-button" @click="save"
        :disabled="runInProgress" variant="primary">
        <b-spinner v-if="runInProgress" small type="grow"/>
        {{$t('message.button_save') | title}}
      </b-button>
    </div>

    <ConsoleOutput v-if="result != null" :result="result" :output="output"/>

    <b-alert v-model="showError" variant="danger" dismissible @dismissed="error=''; showError=false;">
      <div v-html="error"> </div>
      <div v-if="errorRemark"> {{ errorRemark }}</div>
    </b-alert>
  </div>
</template>

<script>
import VueChartist from "v-chartist"
import "chartist/dist/chartist.min.css"
import { get, post } from "../http"
import ConsoleOutput from "./ConsoleOutput"
import {validateEmail} from '../util'

export default {
  name: "DiskSpaceMonitoring",

  components: {
    ConsoleOutput,
    'vue-chartist': VueChartist
  },

  data() {
    return {
      monitoringConfig: {warn_email: '', warning_used_percent: 90},
      error: '',
      showError: false,
      result: null,
      output: '',
      diskSpaceHistoryData: {
        labels: [],
        series: [{
          data: []
        }]
      },
      diskSpaceHistoryOptions: {
        height: "250px",
        fullWidth: true,
        chartPadding: {
            right: 40,
        },
        low: 0,
        axisX: {
          labelOffset: {
            x: -25,
            y: 0
          },
        },
        axisY: {
          labelInterpolationFnc: function(value) {
            return value + '%'
          }
        }
      }
    }
  },

  mounted() {
    this.loadDiskSpaceHistory()
    this.load()
  },

  computed: {
    description() {
      let messageLookup = "message.script_" + this.$route.params.menu + "_" + this.$route.params.script_name + "_description"
      let description = this.$t(messageLookup)
      if (description === messageLookup) {
        return ""
      }
      return description
    }
  },

  methods: {
    getUrl() {
      return ('/scripts/status/disk_space_monitoring')
    },

    save() {
      this.result = null
      this.output = ''

      if (!validateEmail(this.monitoringConfig.warn_email)) {
        this.error = this.$t('message.error_invalid_email') + ': ' + this.monitoringConfig.warn_email
        this.showError = true
        return
      }

      this.runInProgress = true

      let data = {disk_space_monitoring: this.monitoringConfig}

      post(this.getUrl(), data, { "Content-Type": "application/json" }).then(
        resp => {
          this.result = resp.data.result
          this.output = resp.data.output
          this.runInProgress = false

        },
        err => {
          this.runInProgress = false
          console.log("err", err)
        }
      )
    },

    load() {
      get(this.getUrl()).then(
        resp => {
          this.monitoringConfig = resp.data["params"]["disk_space_monitoring"]["value"]
          if (!this.monitoringConfig) {
            this.monitoringConfig = {warn_email: '', warning_percent: 90}
          }
          if (this.monitoringConfig.warning_used_percent == undefined) {
            this.monitoringConfig.warning_used_percent = 90
          }
        },
        err => {
          console.log("err", err)
        }
      )
    },

    loadDiskSpaceHistory() {
      let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      this.diskSpaceHistoryData.series[0].data = []
      this.diskSpaceHistoryData.labels = []
      get('/disk_space_history').then(
        resp => {
          for (let i=0; i<resp.data.data_points.length; i++) {
            let dataPoint = resp.data.data_points[i]
            let date = new Date(dataPoint['timestamp'] * 1000)
            let hours = date.getHours()
            if (hours < 10) {
              hours = '0' + hours
            }
            let mins = date.getMinutes()
            if (mins < 10) {
              mins = '0' + mins
            }
            let dateLabel = months[date.getMonth()] + ' ' + date.getDate() + '\n' + hours + ':' + mins
            this.diskSpaceHistoryData.series[0].data.push({x: date, y: dataPoint['percent'] })
            this.diskSpaceHistoryData.labels.push(dateLabel)
          }
        },
        err => {
          console.log("err", err)
        }
      )
    },
  }
}
</script>
